import { render, staticRenderFns } from "./PracticeBillingPage.vue?vue&type=template&id=cf04b55c&scoped=true"
import script from "./PracticeBillingPage.vue?vue&type=script&lang=js"
export * from "./PracticeBillingPage.vue?vue&type=script&lang=js"
import style0 from "./PracticeBillingPage.vue?vue&type=style&index=0&id=cf04b55c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf04b55c",
  null
  
)

export default component.exports